import MyLocale from '@/models/MyLocale.model';

export const gb = new MyLocale({
	title: 'WB-CPP',

	word: {
		to: 'to',
	},
	message: {
    emptyState: {
      noData: {
        title: 'No data found!',
        message: 'No data found!',
      },
      unknownAuthor: {
        title: 'Unknown author!',
        message: 'Unknown author!',
      },
    },
	},
	filters: {
		dataType: {
			title: 'Climate Insights by Data Source',
      info: 'Explore observed data and model-based scenarios for key climate variables.',
			observation: {
				title: 'Observation',
			},
			scenario: {
				title: 'Scenario',
			},
      mapInfoTitle: 'Dataset',
		},
		variable: {
			title: 'Variables',

			// New variables
			cdd5: 'cdd5',
			cdd7: 'cdd7',
			dhi5: 'dhi5',
			dhi7: 'dhi7',
			ews: 'ews',
			ewc: 'ewc',
			ftd: 'ftd',
			hd30: 'hd30',
			hd40: 'hd40',
			ls: 'ls',
			sdii: 'sdii',
			hs: 'hs',
			sd: 'sd',
			pr: 'pr',
			tmean: 'tmean',
			tasmax: 'tasmax',
			tasmin: 'tasmin',

			// Tooltips for new variables
			cdd5Tooltip: 'cdd5',
			cdd7Tooltip: 'cdd7',
			dhi5Tooltip: 'dhi5',
			dhi7Tooltip: 'dhi7',
			ewsTooltip: 'ews',
			ewcTooltip: 'ewc',
			ftdTooltip: 'ftd',
			hd30Tooltip: 'hd30',
			hd40Tooltip: 'hd40',
			lsTooltip: 'ls',
			sdiiTooltip: 'sdii',
			hsTooltip: 'hs',
			sdTooltip: 'sd',
			prTooltip: 'pr',
			tmeanTooltip: 'tmean',
			tasmaxTooltip: 'tasmax',
			tasminTooltip: 'tasmin',

			// Titles for new variables
			cdd5Title: 'Dry spells (5 days)',
			cdd7Title: 'Dry spells (7 days)',
			dhi5Title: 'Hot days in dry spells (5 days)',
			dhi7Title: 'Hot days in dry spells  (7 days)',
			ewsTitle: 'Wind speed extremes',
			ewcTitle: 'Days exceeding wind speed extremes',
			ftdTitle: 'Freeze-thaw-cycles',
			hd30Title: 'Hot days (30 °C)',
			hd40Title: 'Very hot days (40 °C)',
			lsTitle: 'Critical rainfall conditions for landslides',
			sdiiTitle: 'Precipitation extremes',
			hsTitle: 'Heavy snowfall',
			sdTitle: 'Snowfall',
			prTitle: 'Precipitation amount',
			tmeanTitle: 'Mean temperature',
			tasmaxTitle: 'Maximum temperature',
			tasminTitle: 'Minimum temperature',

			cdd5Description: 'Days in consecutive 5-day periods with less than 1mm precipitation amount during April-September',
			cdd7Description: 'Days in consecutive 7-day periods with less than 1mm precipitation amount during April-September',
			dhi5Description: 'Days in 5-day dry spells exceeding  30°C daily maximum temperature',
			dhi7Description: 'Days in 7-day dry spells exceeding  30°C daily maximum temperature',
			ewsDescription: '99.9-percentile of daily mean wind speeds in the observation period 1981-2010',
			ewcDescription: 'Days exceeding the 99.9-percentile of daily mean wind speeds in the observation period 1981-2010',
			ftdDescription: 'Days with minimum temperature below -2.2 °C and maximum temperature above 0°C',
			hd30Description: 'Days with maximum temperature exceeding 30°C',
			hd40Description: 'Days with maximum temperature exceeding 40°C ',
			lsDescription: 'Days exceeding precipitation intensity thresholds after the Moser-Hohensinn approach (M = 41.66 * (h-0.77) * h) for h = 24, 48 and 72 hours',
			sdiiDescription: '99.9 percentile of daily precipitation amounts within 30-year periods',
			hsDescription: 'Days with precipitation amount above 10mm and mean temperature below 0 °C',
			sdDescription: 'Days with precipitation amount above 1mm and mean temperature below 0 °C',
			prDescription: 'Daily precipitation amount',
			tmeanDescription: 'Daily mean air temperature',
			tasmaxDescription: 'Daily maximum air temperature',
			tasminDescription: 'Daily minimum air temperature',
		},
		period: {
			title: 'Period',
      '1981-2010': '1981-2010',
      '2011-2040': '2011-2040',
      '2001-2020': '2001-2020',
      '2036-2065': '2036-2065',
      '2071-2100': '2071-2100',
		},
    scenario: {
      title: 'Scenario',
      ens: 'ENS',
      rcp26: 'RCP2.6 (Low Emissions Future)',
      rcp45: 'RCP4.5 (Moderate Emissions Future)',
      rcp85: 'RCP8.5 (High Emissions Future)',
    },
		season: {
			title: 'Season',
      'yr': 'Annual',
      '01': 'January',
      '02': 'February',
      '03': 'March',
      '04': 'April',
      '05': 'May',
      '06': 'June',
      '07': 'July',
      '08': 'August',
      '09': 'September',
      '10': 'October',
      '11': 'November',
      '12': 'December',
		},
		gwl: {
			title: 'Global warming level',
      '1.5': 'GWL1.5',
      '2.0': 'GWL2.0',
      '3.0': 'GWL3.0',
      '4.0': 'GWL4.0',
		},
		gridSpacing: {
			title: 'Gridspacing',
      '01deg': '01deg',
		},
		author: {
      title: 'Author',
      defaultLabel: 'Select Author',
    }
	},
	options: {
		download: {
			image: 'Image',
			pdf: 'PDF',
			file: 'File',
		},
	},
	legend: {
		min: 'min',
		max: 'max',
	},
	mapDetails: {
		value: 'value',

		ens: 'median',
		ens75: '75th percentile',
		ens25: '25th percentile',

    noCsvData: 'There is no csv data for this point',
    subgridToggleLabel: 'Show 30\'\' grid',
    subgridToggleOnInfo: 'Enabling 30\'\' grid for this cell will also show 30\'\' grid for all the neighboring cells',
    subgridToggleOffInfo: 'Select a 30\'\' cell to preview it\'s data.',
	},
	tour: {
		closeButton: 'Close',
		backButton: 'Back',
		nextButton: 'Next',
		completeButton: 'Complete',
		startButton: 'Start platform tour',
	},
	unit: {
		Celsius: '°C',
		'%': '%',
		mm: 'mm',
    d: 'd',
    'm s-1': 'm s-1',
	},
  mapView: {
    noneValue: 'None',
    terrain: 'Terrain',
    satellite: 'Satellite',
  },
  mapOptions: {
    showClimateData: 'Show Climate Data',
  },
  footer: {
    kosovoBorderLabel: 'This designation is without prejudice to positions on status, and is in line with UNSCR 1244/99.',
  },
  nav: {
    map: 'Map',
  },
});
